/* ORAMA — core theme behavior. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('orama-config').textContent); } catch (e) {}
  var rtl = document.documentElement.dir === 'rtl';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function withCommas(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }
  window.OramaFormatMoney = formatMoney;

  /* ---------- HTML escaping (cart line items may carry buyer input) ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escAttr(s) { return esc(s); }

  /* ---------- Pixel helpers ---------- */
  window.oramaTrack = function (event, data) {
    if (window.fbq) { try { fbq('track', event, data || {}); } catch (e) {} }
    if (window.ttq) {
      var map = { ViewContent: 'ViewContent', AddToCart: 'AddToCart', InitiateCheckout: 'InitiateCheckout', Purchase: 'CompletePayment' };
      if (map[event]) { try { ttq.track(map[event], data || {}); } catch (e) {} }
    }
  };

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Header shrink on scroll ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 12);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var bodyEl = document.body;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    bodyEl.classList.add('no-scroll');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    bodyEl.classList.remove('no-scroll');
    drawer.setAttribute('aria-hidden', 'true');
  }
  window.OramaCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function t(key, fallback) {
    var s = (cfg.strings && cfg.strings[key]) || fallback;
    return String(s)
      .replace(/&#(\d+);/g, function (_, code) { return String.fromCharCode(code); })
      .replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }

  function renderCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hide', count === 0);
    });
    var itemsWrap = drawer && drawer.querySelector('[data-cart-items]');
    var footer = drawer && drawer.querySelector('[data-cart-footer]');
    var emptyEl = drawer && drawer.querySelector('[data-cart-empty]');
    if (!itemsWrap) return;

    if (count === 0) {
      itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.classList.remove('hide');
      if (footer) footer.classList.add('hide');
      return;
    }
    if (emptyEl) emptyEl.classList.add('hide');
    if (footer) footer.classList.remove('hide');

    itemsWrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1$2') : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' · ');
      var qty = parseInt(it.quantity, 10) || 0;
      return '' +
      '<div class="cart-item" data-key="' + escAttr(it.key) + '">' +
        '<a href="' + escAttr(it.url) + '" class="cart-item__img">' + (img ? '<img src="' + escAttr(img) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
        '<div class="cart-item__info">' +
          '<a href="' + escAttr(it.url) + '" class="cart-item__title">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="cart-item__opts">' + esc(opts) + '</div>' : '') +
          '<div class="cart-item__row">' +
            '<div class="qty" data-qty>' +
              '<button type="button" data-qty-down aria-label="-">−</button>' +
              '<input type="text" inputmode="numeric" value="' + qty + '" data-qty-input aria-label="quantity">' +
              '<button type="button" data-qty-up aria-label="+">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + esc(formatMoney(it.final_line_price)) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-remove>' + esc(t('remove', 'Remove')) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');

    refreshSavings();

    // Active bundle-tier chip (mirrors the product page "Buy more, save more" tiers)
    var tierEl = drawer.querySelector('[data-cart-tier]');
    if (tierEl) {
      if (count >= 3) {
        tierEl.innerHTML = t('tier3Active', '✓ 3-Box bundle applied — 20% OFF + Free delivery');
        tierEl.classList.remove('hide');
      } else if (count === 2) {
        tierEl.innerHTML = t('tier2Active', '✓ 2-Box bundle applied — 10% OFF + Free delivery');
        tierEl.classList.remove('hide');
      } else {
        tierEl.classList.add('hide');
      }
    }

    // Free shipping + bundle-discount milestone bar.
    // Progress uses the PRE-discount subtotal so milestones ($49 / $65) match
    // the prices customers see on product pages; the real shipping rule sits
    // lower ($44) so the promise still holds after the 10% bundle discount.
    var bar = drawer.querySelector('[data-ship-bar]');
    if (bar && cfg.freeShipThreshold) {
      var t1 = cfg.freeShipThreshold * 100;
      var t2 = (cfg.discountMilestone || 65) * 100;
      var pre = (cart.original_total_price != null) ? cart.original_total_price : cart.total_price;
      var pct = Math.min(100, Math.round((pre / t2) * 100));
      var fill = bar.querySelector('[data-ship-fill]');
      var label = bar.querySelector('[data-ship-label]');
      if (fill) fill.style.width = pct + '%';
      var d1 = bar.querySelector('[data-ship-dot-1]');
      var d2 = bar.querySelector('[data-ship-dot-2]');
      if (d1) d1.classList.toggle('is-hit', pre >= t1);
      if (d2) d2.classList.toggle('is-hit', pre >= t2);
      if (label) {
        var msg;
        if (pre >= t2) {
          msg = t('freeShipDone', '<strong>Free Shipping + 20% Extra Discount unlocked 🎉</strong>');
        } else if (pre >= t1) {
          msg = t('freeShipTier2', '<strong>Free Shipping + 10% Extra Discount unlocked 🎉</strong> — add <strong>{{ amount }}</strong> to unlock an <strong>extra 20% Discount</strong>')
            .replace('{{ amount }}', esc(formatMoney(t2 - pre)));
        } else {
          msg = t('freeShipLeft', 'Add <strong>{{ amount }}</strong> to unlock <strong>Free Shipping + Extra 10% Discount</strong>')
            .replace('{{ amount }}', esc(formatMoney(t1 - pre)));
        }
        label.innerHTML = msg;
      }
    }
  }

  /* Subtotal + "You saved" — server-rendered (compare-at prices aren't in /cart.js) */
  function refreshSavings() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-savings', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-savings'];
        if (!html) return;
        var host = document.getElementById('shopify-section-cart-savings');
        if (!host) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-cart-savings');
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  // Quantity + remove inside drawer
  document.addEventListener('click', function (e) {
    var row = e.target.closest('.cart-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var input = row.querySelector('[data-qty-input]');
    var qty = parseInt(input ? input.value : '1', 10) || 1;
    if (e.target.closest('[data-qty-up]')) changeItem(key, qty + 1);
    else if (e.target.closest('[data-qty-down]')) changeItem(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-remove]')) changeItem(key, 0);
  });

  function changeItem(key, quantity) {
    if (drawer) drawer.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  /* ---------- Add to cart (delegated) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: formData
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.data; }
        var item = res.data;
        window.oramaTrack('AddToCart', {
          content_ids: [item.product_id], content_type: 'product',
          content_name: item.product_title, value: item.final_line_price / 100,
          currency: cfg.currency || 'USD', contents: [{ id: item.variant_id, quantity: item.quantity }]
        });
        return refreshCart();
      })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart';
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = msg; note.classList.remove('hide'); }
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.innerHTML = original; } });
  });

  // Track InitiateCheckout
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-checkout]')) {
      window.oramaTrack('InitiateCheckout', { currency: cfg.currency || 'USD' });
    }
  });

  // Initial paint
  refreshCart();

  /* ---------- Reel sound toggle (owner 2026-07-16) ----------
     Videos autoplay muted 24/7; the small button unmutes ONE video at a time. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reel-sound]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.reel__video');
    var vid = wrap && wrap.querySelector('video');
    if (!vid) return;
    var turnOn = vid.muted;
    document.querySelectorAll('.reel__video video').forEach(function (v) { v.muted = true; });
    document.querySelectorAll('[data-reel-sound].is-on').forEach(function (b) { b.classList.remove('is-on'); });
    if (turnOn) {
      vid.muted = false;
      btn.classList.add('is-on');
      vid.play().catch(function () {});
    }
  });

  /* ---------- Language gate ---------- */
  var gate = document.querySelector('[data-lang-gate]');
  if (gate) {
    // Owner rule (2026-07-15): ask on EVERY entry and refresh — stay quiet only
    // while browsing between our own pages (same-origin referrer, not a reload).
    var navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
    var isReload = navEntry ? navEntry.type === 'reload' : !!(performance.navigation && performance.navigation.type === 1);
    var internalNav = false;
    try { internalNav = !!document.referrer && new URL(document.referrer).origin === window.location.origin; } catch (err) {}
    if (isReload || !internalNav) {
      requestAnimationFrame(function () { gate.classList.add('is-open'); bodyEl.classList.add('no-scroll'); });
    }
    gate.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-lang-choice]');
      if (!opt) return;
      var url = opt.getAttribute('data-lang-url');
      gate.classList.remove('is-open'); bodyEl.classList.remove('no-scroll');
      // If a different locale is required, navigate to its root.
      if (url && opt.getAttribute('data-current') !== 'true') { window.location.href = url; }
    });
  }
})();

